module.exports = __webpack_public_path__ + "img/mobile.06507519.png";